import { render, staticRenderFns } from "./TwCollapse.vue?vue&type=template&id=4d7de943&scoped=true&"
import script from "./TwCollapse.vue?vue&type=script&lang=js&"
export * from "./TwCollapse.vue?vue&type=script&lang=js&"
import style0 from "./TwCollapse.vue?vue&type=style&index=0&id=4d7de943&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7de943",
  null
  
)

export default component.exports